function getEnvVariable(key: string): string | undefined {
  return window._env_?.[key] || import.meta.env[key];
}

export const DASHBOARD_URL = getEnvVariable('VITE_DASHBOARD_URL') ?? '';
